import React from "react";
import { Boxes, Wifi, WifiOff, CircleSlash, MonitorSmartphone } from "lucide-react";
import { useLang } from "@/i18n";

export default function StatsBar({ stats, onSelect, active = "all" }) {
  const { t } = useLang();
  const cards = [
    { key: "total", label: t("total"), value: stats.total, Icon: Boxes, color: "text-gray-900", ring: "border-gray-200", bg: "bg-gray-50" },
    { key: "online", label: t("online"), value: stats.online, Icon: Wifi, color: "text-green-600", ring: "border-green-500/30", bg: "bg-green-500/10", pulse: true },
    { key: "tv_reachable", label: t("tv_reachable"), value: stats.tv_reachable, Icon: MonitorSmartphone, color: "text-amber-600", ring: "border-amber-500/30", bg: "bg-amber-500/10" },
    { key: "offline", label: t("offline"), value: stats.offline, Icon: WifiOff, color: "text-[#c00000]", ring: "border-[#c00000]/30", bg: "bg-[#c00000]/10" },
    { key: "no_agent", label: t("no_agent"), value: stats.no_agent, Icon: CircleSlash, color: "text-gray-600", ring: "border-gray-200", bg: "bg-gray-50" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
      {cards.map((c, i) => {
        const filterVal = c.key === "total" ? "all" : c.key;
        const isActive = active === filterVal;
        return (
          <button
            key={c.key}
            data-testid={`stat-${c.key}`}
            onClick={() => onSelect && onSelect(filterVal)}
            title={c.key === "total" ? "Filter zurücksetzen" : `Nach „${c.label}" filtern`}
            className={`bg-white border border-gray-200 rounded-2xl p-4 sm:p-5 fade-up text-left transition-all cursor-pointer hover:border-[#c00000] hover:-translate-y-0.5 ${isActive ? "ring-2 ring-offset-0 " + c.ring.replace("border-", "ring-") + " border-transparent" : ""}`}
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-mono uppercase tracking-wider text-gray-600">{c.label}</span>
              <div className={`w-8 h-8 rounded-lg border ${c.ring} ${c.bg} flex items-center justify-center ${c.pulse ? "pulse-dot" : ""}`}>
                <c.Icon className={`w-4 h-4 ${c.color}`} />
              </div>
            </div>
            <div className={`font-display text-2xl font-bold ${c.color}`}>{c.value ?? 0}</div>
          </button>
        );
      })}
    </div>
  );
}
